import { render } from "./ProjectsPortfolio.vue?vue&type=template&id=7e7bc88a"
import script from "./ProjectsPortfolio.vue?vue&type=script&lang=js"
export * from "./ProjectsPortfolio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__